// @ts-nocheck
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useSharePost = () => {
  const [isSharing, setIsSharing] = useState(false);

  const getPostUrl = (postId: string) => {
    return `${window.location.origin}/wall/post/${postId}`;
  };

  const incrementShareCount = async (postId: string) => {
    try {
      await supabase.rpc('increment_share_count', { p_post_id: postId });
    } catch (error) {
      console.error('Error incrementing share count:', error);
    }
  };

  const copyLink = async (postId: string) => {
    try {
      const url = getPostUrl(postId);
      await navigator.clipboard.writeText(url);
      await incrementShareCount(postId);
      toast.success('Link copied to clipboard!');
      return true;
    } catch (error) {
      toast.error('Failed to copy link');
      return false;
    }
  };

  const shareToTwitter = async (postId: string, content: string, authorName: string) => {
    const url = getPostUrl(postId);
    const truncatedContent = content.length > 200 ? content.substring(0, 200) + '...' : content;
    const text = `${truncatedContent} via @RecruitLook`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    
    window.open(twitterUrl, '_blank', 'width=550,height=420');
    await incrementShareCount(postId);
  };

  const shareToInstagram = async (postId: string, content: string) => {
    // Instagram doesn't have a web share API, so we copy to clipboard with instructions
    const url = getPostUrl(postId);
    const textToCopy = `${content}\n\n${url}`;
    
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success('Caption copied! Paste in Instagram.');
      await incrementShareCount(postId);
      return true;
    } catch (error) {
      toast.error('Failed to copy caption');
      return false;
    }
  };

  return {
    isSharing,
    setIsSharing,
    copyLink,
    shareToTwitter,
    shareToInstagram,
    getPostUrl,
    incrementShareCount,
  };
};
